// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"6b8c7c43","223":"40371cd5","358":"7957fb00","390":"eec94010","453":"5c7a3aed","474":"cab8557e","494":"bd2f0f0c","503":"b29caf61","626":"503e5d2b","631":"d2bc8b90","790":"6da2ebae","795":"7fe16e89","824":"a3167e7e","844":"2178c4fc","953":"20ed8018"}[chunkId] + ".chunk.js";
};